
import { useState } from "react";
import { useOrganizationData } from "./useOrganizationData";
import { useOrganizationUpdate } from "./useOrganizationUpdate";
import type { UseOrganizationSettingsReturn } from "./types";

export const useOrganizationSettings = (): UseOrganizationSettingsReturn => {
  const { organization, isLoading, setOrganization } = useOrganizationData();
  const { isSaving, updateOrganization } = useOrganizationUpdate(organization, setOrganization);
  const [orgName, setOrgName] = useState(organization?.name || "");

  return {
    organization,
    orgName,
    setOrgName,
    isLoading,
    isSaving,
    updateOrganization,
  };
};
